export class AdvisorConstants {
    /**
     * The label to use when no advisor is assigned.
     */
    static readonly NoneAssigned = 'None Assigned';

    /**
     * The label to use when an advisor is assigned but does not have a name.
     */
    static readonly UnnamedAdvisor = 'Unnamed Advisor';
}
